import React, { useState, useEffect } from 'react';
import { Menu, X, Home, Info, FileCheck, Mail } from 'lucide-react';
import { Link as LinkRouter } from 'react-router-dom';
import {
  HOME_ROUTE,
  ABOUT_ROUTE,
  WORK_ROUTE,
  CONTACT_ROUTE,
  VEDIKSHA_ROUTE,
  SERVICE_ROUTE,
  GALLARY_ROUTE
} from '../../routes/web/rootRoutes';

const Link = ({ to, children, className, onClick }) => (
  <LinkRouter to={to} className={className} onClick={onClick}>
    {children}
  </LinkRouter>
);

function Header({ LOGOMAIN, width }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const mainMenuItems = [
    { key: 'home', label: 'Home', path: HOME_ROUTE },
    { key: 'about', label: 'About Us', path: ABOUT_ROUTE },
    { key: 'service', label: 'Service', path: SERVICE_ROUTE },
    { key: 'work', label: 'Our Work', path: WORK_ROUTE },
    { key: 'vedik', label: 'Vedikshha', path: VEDIKSHA_ROUTE },
    { key: 'gallary', label: 'Gallary', path: GALLARY_ROUTE },
    { key: 'contact', label: 'Contact', path: CONTACT_ROUTE },
  ];

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleMenuClick = (key) => {
    setActiveMenu(key);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-[1000]">
      {/* TOP STRIP – scroll pe hide */}
      {!isScrolled && (
        <div className="bg-gradient-to-r from-green-400 to-green-600 text-white py-2 px-4">
          <div className="max-w-7xl mx-auto text-center text-sm font-semibold">
            ✨ Kaanshi Films Entertainment – Turning Ideas into Impactful Films
          </div>
        </div>
      )}

      {/* NAVBAR */}
      <nav
        className={`bg-white transition-all duration-300 ${
          isScrolled ? 'shadow-xl py-2' : 'shadow-lg py-3'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link
              to={HOME_ROUTE}
              onClick={() => handleMenuClick('home')}
              className="flex items-center"
            >
              <img
                src={LOGOMAIN}
                alt="Logo"
                className={`${width} object-contain`}
              />
            </Link>

            {/* DESKTOP MENU */}
            <div className="hidden lg:flex items-center space-x-1">
              {mainMenuItems.map((item) => (
                <Link
                  key={item.key}
                  to={item.path}
                  onClick={() => handleMenuClick(item.key)}
                  className="relative px-4 py-2 text-gray-800 hover:text-green-700 font-medium transition group"
                >
                  <span className={activeMenu === item.key ? 'text-green-700' : ''}>
                    {item.label}
                  </span>

                  <span
                    className={`absolute bottom-0 left-4 right-4 h-0.5 bg-green-600 transition-transform duration-300
                    ${
                      activeMenu === item.key
                        ? 'scale-x-100'
                        : 'scale-x-0 group-hover:scale-x-100'
                    }`}
                  />
                </Link>
              ))}
            </div>

            {/* MOBILE TOGGLE BUTTON */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2"
            >
              {isMobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {/* MOBILE MENU */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t shadow-md">
            {mainMenuItems.map((item) => (
              <Link
                key={item.key}
                to={item.path}
                onClick={() => handleMenuClick(item.key)}
                className="block px-6 py-4 text-gray-700 hover:bg-green-50 hover:text-green-700 font-medium"
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}

export default Header;
